import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { getEventCode } from "ContentActions";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { MAIN_URL, COMMON_FAIL_MESSAGE, DOMAIN_NAME } from "Constants";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LocaleStrings from "Languages";
import _ from "lodash";

class CopyEmbeddedCode extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      loading: false,
      showModal: false,
      seoCode: "",
    };
  }

  open() {
    this.setState({ showModal: true });
  }

  close() {
    this.setState({ showModal: false });
  }

  copyUrl = () => {
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  getEventCode = () => {
    if (
      !_.isEmpty(this.props.eventDetails) &&
      !_.isEmpty(this.props.eventDetails.seocode)
    ) {
      this.setState({ seoCode: this.props.eventDetails.seocode });
      this.setState({ showModal: true });
    } else {
      this.props.showError(COMMON_FAIL_MESSAGE);
    }
  };

  render() {
    let {} = this.props;

    let url = `<iframe src=https://${this.state.seoCode}.${DOMAIN_NAME}/widget/sessions title="Event Schedules"></iframe>`;

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          bsStyle=""
          onClick={(e) => this.getEventCode(e)}
          loading={this.state.loading}
        >
          {/* <i className="fa fa-code i-custom-m" aria-hidden="true" />
            Generate Embed Code */}
          <i className="fa fa-code i-custom-ms" aria-hidden="true" />
          {LocaleStrings.schedule_code}
        </Button>

        <Modal
          className="modal-container"
          show={this.state.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.schedule_embed_code}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={(e) => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control"
              disabled={true}
              style={{ height: 78 }}
            >
              {url}
            </textarea>
          </Modal.Body>
          <Modal.Footer>
            <CopyToClipboard text={url} onCopy={this.copyUrl}>
              {this.state.copied ? (
                <button className="btn btn-custom-blue btn-v-center">
                  <i className="fa fa-check i-custom-m" aria-hidden="true"></i>
                  &nbsp; {LocaleStrings.copied}
                </button>
              ) : (
                <button className="btn btn-custom-blue btn-v-center">
                  <i className="fa fa-copy i-custom-m" aria-hidden="true"></i>
                  &nbsp; {LocaleStrings.button_copy}
                </button>
              )}
            </CopyToClipboard>

            <Button
              bsStyle=""
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  getEventCode,
})(CopyEmbeddedCode);
